import { isDefined } from "@clipboard-health/util-ts";
import { useParams } from "react-router-dom";

import { ShiftDetailsErrorPage } from "../components/ShiftDetailsErrorPage";
import { useGetPastShiftDetailsData } from "./api/useGetPastShiftDetailsData";
import { PastShiftDetailsPage } from "./Page";
import { PastShiftDetailsSkeleton } from "./Skeleton";

export function PastShiftDetailsRoute(): JSX.Element {
  const { shiftId } = useParams<{ shiftId: string }>();

  const { data, isLoading, isError, refetchExtraWorkedTimeRequests } = useGetPastShiftDetailsData({
    shiftId,
  });

  if (isLoading) {
    return <PastShiftDetailsSkeleton />;
  }

  if (isError || !isDefined(data)) {
    return <ShiftDetailsErrorPage />;
  }

  return (
    <PastShiftDetailsPage
      data={data}
      refetchExtraWorkedTimeRequests={refetchExtraWorkedTimeRequests}
    />
  );
}
